module.exports = __webpack_public_path__ + "static/img/4.fa089fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/4.png
// module id = S7Ss
// module chunks = 0